/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_SearchInputs */

const en_views_search = /** @type {(inputs: Views_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a view`)
};

const de_views_search = /** @type {(inputs: Views_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansicht suchen`)
};

/**
* | output |
* | --- |
* | "Find a view" |
*
* @param {Views_SearchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_search = /** @type {((inputs?: Views_SearchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_SearchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_search(inputs)
	return en_views_search(inputs)
});